import { NotificationsApi } from './types';

const base = '/notifications';

export const notificationsApi: Readonly<NotificationsApi> = {
  notificaciones: (filters) => `${base}/${filters}}`,
  notificacionPorId: (filters, id) => `${base}/${id}${filters}`,
  preferencias: (filters) => `${base}/preferencias/${filters}`,
  notificacionLeida: (filters) => `${base}/${filters}`,
};
